/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The SetUserPasswordResponse model module.
* @module model/SetUserPasswordResponse
* @version 2020-12-7
*/
export default class SetUserPasswordResponse {
    /**
    * Constructs a new <code>SetUserPasswordResponse</code>.
    * パスワード変更レスポンス
    * @alias module:model/SetUserPasswordResponse
    * @class
    * @param result {module:model/SetUserPasswordResponse.ResultEnum} 
    */

    constructor(result) {
        
        
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SetUserPasswordResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SetUserPasswordResponse} obj Optional instance to populate.
    * @return {module:model/SetUserPasswordResponse} The populated <code>SetUserPasswordResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SetUserPasswordResponse();
                        
            
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {module:model/SetUserPasswordResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
